import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import axios from 'axios';
import { FormattedHTMLMessage } from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import Section from './Section.js';
import AttributeOptions from './AttributeOptions.js';
import CustomSpinner from './CustomSpinner.js';
import SaveStepButton from './SaveStepButton';
import Whatsapp from './WhatsappButton.js';
import CustomAlert from './CustomAlert';
import generateValidator from './Validations/generateValidator';

class MinWageForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            minWage: null,
            isLoading: true,
            error: null
        };
    }

    componentDidMount() {
        const ROOT_URL = process.env.API_URL;
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
        };

        axios.get(`${ROOT_URL}/subscribers/min_wage`, config)
            .then(response => {
                this.setState({
                    minWage: response.data.min_wage,
                    isLoading: false
                });
            })
            .catch(error => {
                this.setState({
                    error: 'Error al obtener el monto mínimo',
                    isLoading: false
                });
            });
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;
        const { minWage, isLoading } = this.state;
        const wage_options = [{id: 0, name: 'Si'}, {id: 1, name: 'No'}];

        if (isLoading) {
            return <CustomSpinner message='Cargando...' />;
        }

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_min_wage" description="Minimum wage confirmation"/>
                        <div className="show-desktop">
                            <Whatsapp phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                            <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                            <SaveStepButton/>
                        </div>
                    </div>
                    <div className="pd-content-right text-center short-content col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveMinWage)} className="pvc-form">
                            {this.state.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' />}
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <AttributeOptions
                                            name="min_wage_confirm"
                                            defaultValue={`¿El monto es superior a ${minWage || 0}?`}
                                            label={`¿El monto es superior a ${minWage || 0}?`}
                                            attributeName='min_wage_confirm'
                                            attributeOptions={wage_options}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>
                                        Continuar
                                    </button>
                                </div>
                            </div>
                        </form>
                        <div className="show-mobile">
                            <Whatsapp phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                            <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                            <SaveStepButton/>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

MinWageForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
};

MinWageForm = TopScrolleable(MinWageForm);
let validate = generateValidator([{name: 'min_wage_confirm', required: true}]);

export default reduxForm({
    form: 'MinWageForm',
    validate
})(withAuthControl(MinWageForm));



/** WEBPACK FOOTER **
 ** ./src/components/MinWageForm.js
 **/